<script>
export default {
    name: 'Footer',
    props: ['checkoutCustom', 'storeData'],
    data() {
        return {}
    },
}
</script>
<template>
    <footer class="-mobile-center">
        <div class="container">
            <div
                class="payment-methods-holder"
                v-if="
                    checkoutCustom.footer_configs.includes(
                        'show_payment_options'
                    )
                "
            >
                <div class="-title">Formas de pagamento</div>
                <div class="-payment-list">
                    <img
                        alt="amex"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-amex.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="visa"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-visa.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="diners"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-diners.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="mastercard"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-mastercard.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="discover"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-discover.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="aura"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-aura.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="hipercard"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-hipercard.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="elo"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-elo.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="hiper"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-hiper.svg"
                    />
                    <span class="line-break hide"></span>
                    <img
                        alt="pix"
                        width="39"
                        height="26"
                        src="https://icons.yampi.me/svg/card-pix.svg"
                    />
                    <img
                        alt="boleto"
                        width="39"
                        height="23"
                        src="https://img.icons8.com/?size=100&id=77599&format=png&color=000000"
                    />
                    <span class="line-break hide"></span>
                </div>
            </div>
            <div
                class="store-info-holder"
                v-if="checkoutCustom.footer_configs.includes('show_store_name')"
            >
                <div class="-store-name" v-if="storeData.title">
                    {{ storeData.title }}
                </div>

                <div
                    class="-address space-handler"
                    v-if="
                        storeData.street_name &&
                        checkoutCustom.footer_configs.includes(
                            'show_store_address'
                        )
                    "
                >
                    <span
                        ><span v-if="storeData.street_name"
                            >{{ storeData.street_name }},</span
                        >
                        <span v-if="storeData.street_number"
                            >{{ storeData.street_number }},</span
                        >
                        <span v-if="storeData.complement">{{
                            storeData.complement
                        }}</span>
                        <span v-if="storeData.neighborhood"
                            >- {{ storeData.neighborhood }}</span
                        ></span
                    >
                    <span v-if="storeData.city"
                        >{{ storeData.city }} - {{ storeData.state }}</span
                    >
                </div>

                <div
                    class="-store-document space-handler"
                    v-if="
                        checkoutCustom.footer_configs.includes(
                            'show_store_document'
                        )
                    "
                >
                    <span class="-holder-store-name"
                        >© {{new Date().getFullYear()}} {{ storeData.legal_name }}</span
                    >
                    <span class="-holder-document" v-if="storeData.document"
                        >CNPJ:
                        <span class="cnpj">{{ storeData.document }}</span>
                    </span>
                </div>
            </div>

            <div
                class="space-handler contact-holder"
                v-if="
                    checkoutCustom.footer_configs.includes('show_store_contact')
                "
            >
                <span class="-whatsapp" v-if="storeData.phone_number"
                    >Whatsapp:
                    {{ storeData.phone_number }}
                </span>

                <span class="-whatsapp" v-if="storeData.email"
                    >E-mail:
                    {{ storeData.email }}
                </span>
            </div>

            <div
                class="security-label"
                v-if="
                    checkoutCustom.footer_configs.includes(
                        'show_security_seals'
                    )
                "
            >
                <img src="/img/securepayment.svg" />
            </div>
        </div>
    </footer>
</template>
